export enum RemainingVacancies {
  ALL = "All",
  POSITIVE = "Positive",
  NEGATIVE = "Negative",
}
